import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts.accounts', {
        url: '/accounts',
        views: {
            '': 'userSharedAccounts',
            'header@user': 'userSharedAccountsHeader',
        },
        resolve: {applications,sharedAccounts,companies,allAccounts},
    })
}

/** @ngInject */
function applications(ApplicationService) {
    return ApplicationService.findAll().$promise
        .then(items => items.map((account) => ({...account, objType: 'APPLICATION'})));
}

/** @ngInject */
function sharedAccounts($filter, UsersSharedAccountService) {
    return UsersSharedAccountService.usersCompanySharedAccounts.query().$promise
        .then(items => $filter('orderBy')(items, 'publicService.serviceName'))
        .then(items => items.map((account) => ({...account, applicationName: serviceDisplayName(account)})))
        .then(items => items.map((account) => ({...account, objType: 'SHARED_ACCOUNT'})))
        .then(items => items.map((account) => ({...account, companyName: account.company.companyName})))
        .then(items => items.map((account) => ({...account, status: 'ACTIVE'})))
}

/** @ngInject */
function allAccounts(applications, sharedAccounts) {
    return [...applications, ...sharedAccounts];
}

function serviceDisplayName(account) {
    let displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other'){
        displayName = account.customServiceName;
    }
    return displayName;
}

/** @ngInject */
function companies(UsersSharedAccountService) {
    var coms= UsersSharedAccountService.usersCompanySharedAccounts.getCompaniesToShareWith().$promise;
    return coms;
    
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.state.js